/**
 * İngilizce arayüz paketi (M6 WP 6.2) — KISMİ örtü. Plan §4 gereği İngilizce çeviri içeriği kapsam dışıdır; bu dosya dil
 * altyapısının çalıştığını gösteren çekirdek kabuk metinlerini (menü, kabuk) içerir. Burada olmayan her metin Türkçe
 * gösterilir (`mergeDictionary`); ayar ekranı kapsamı sayıyla yazar. Yeni çeviri eklemek için yalnız bu dosya genişletilir.
 */
import type { DictionaryOverlay } from './language';
import type { Dictionary } from './tr';

export const en: DictionaryOverlay<Dictionary> = {
  nav: {
    overview: 'Overview',
    feed: 'News feed',
    companies: 'Companies',
    contacts: 'Contacts',
    products: 'Products',
    transfers: 'Transfers',
    sales: 'Sales',
    areaCrm: 'CRM',
    areaComms: 'Communication',
    areaMarketing: 'Marketing',
    areaWork: 'Work',
    areaReports: 'Reports',
    leads: 'Leads',
    contracts: 'Contracts',
    opportunities: 'Opportunities',
    opportunityBoard: 'Opportunity board',
    proposals: 'Quotations',
    orders: 'Orders',
    purchaseOrders: 'Purchase orders',
    suppliers: 'Suppliers',
    approvals: 'Pending approvals',
    administration: 'Administration',
    adminOrg: 'Organization and team',
    adminRules: 'Customization and business rules',
    adminConnections: 'Connections and communication',
    adminPlanUsage: 'Plan and usage',
    adminData: 'Data, security and account',
    users: 'Users',
    settings: 'Settings',
    workCalendar: 'Work calendar',
    publicLinks: 'Web forms and links',
    automation: 'Automation',
    email: 'Email',
    inboundEmail: 'Inbound email',
    leadOverview: 'Lead overview',
    leadSequences: 'Lead sequences',
    orderBoard: 'Order board',
    activities: 'Activities',
    activityBoard: 'Activity board',
    activityCalendar: 'Calendar',
    activityMap: 'Activity map',
    performance: 'Performance',
    dashboard: 'Dashboard',
    goals: 'Goals',
    activityReport: 'Activity report',
    tickets: 'Tickets',
    supportOverview: 'Support overview',
    forms: 'Forms',
    formDocuments: 'Form documents',
    gamification: 'Points and badges',
    gamificationSettings: 'Gamification',
  },
  shell: {
    soon: 'Soon',
    userMenu: (name: string) => `User menu: ${name}`,
    workspace: 'Workspace',
    systemStatus: 'System status',
    logout: 'Sign out',
    checkingSession: 'Checking session',
  },
};
